// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

// @actions

// @helpers
const signaturePatternActions = require('actions/signaturePattern');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER,
    BROKER_TRANSFER_PENSION_PLAN_ORIGIN,
    BROKER_TRANSFER_PENSION_PLAN_DESTINATION,
    BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION,
    BROKER_TRANSFER_PENSION_PLANS_DEST_NEW_OPTION,
    BROKER_PLANS_DOCUMENTS_CATEGORY,
    BROKER_PLANS_TRANSFER_DOCUMENTS_SUBCATEGORY,
    BROKER_HIRE_PENSION_PLAN_SUB_CATEGORY,
    BROKER_PLAN_LEGAL_DOCUMENT_DDFP,
    SPAIN_PLANS_UNIVERSE_ID,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP
} = require('constants/index');

const setOriginPlan = planData => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_SELECT_ORIGIN,
    payload: {
        planData
    }
});

const setDestinationPlan = planData => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_SELECT_DESTINATION,
    payload: {
        planData
    }
});

const setAvailableDestinationPlans = (plans, isPlanFromWallet) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_UPDATE_DESTINATION_PLANS,
    payload: {
        plans,
        isPlanFromWallet
    }
})

const validateStep = step => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_VALIDATE_STEP,
        payload: {
            step
        }
    });
}

const setVisibleStep = step => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_SET_VISIBLE_STEP,
        payload: {
            step
        }
    })
}

const changeAmountInput = amount => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_CHANGE_AMOUNT,
        payload: {
            amount
        }
    })
}

const reset = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_RESET
    });
}

const setWillCancel = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_WILL_CANCEL
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_WILL_LEAVE
});

const setAmountRange = () => (dispatch, getState) => {
    const minimumAmount = getState().brokerTransferPensionPlansInternal
        .getIn(['steps', SECOND_STEP, 'destinationPlanData', 'comercialData', 'CustomMinimumPurchaseAmount']);
    const maximumAmount = getState().brokerTransferPensionPlansInternal
        .getIn(['steps', FIRST_STEP, 'originPlanData', 'totalValueEur', 'amount']);
    dispatch ({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_SET_AMOUNT_RANGE,
        payload: {
            minimumAmount,
            maximumAmount
        }
    })
}

/* Actions to fetch pension fund and gestor entity. **************************** */
const requestPensionPlanInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_DATA_REQUEST
});

const requestPensionPlanSuccess = (response) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_SUCCESS,
    payload: {
        securityDetails: response[0]
    }
});

const requestPensionPlanNotFound = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_NOT_FOUND
})

const requestPensionPlanFailure = (error) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_FAILURE,
    payload: {
        error
    }
});

const getPensionPlanDetails = (secId) => (dispatch) => {
    const typeId = BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;

    dispatch(requestPensionPlanInProgress);

    const requestData = {
        query: {
            viewId: 'full',
            LanguageId: 'es-ES',
            responseViewFormat: 'json'
        }
    }

    dispatch(requestPensionPlanInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {type:typeId, id:secId}), requestData)
        .then( response => {
            dispatch(requestPensionPlanSuccess(response));
        })
        .catch(response => {
            if (response.error) {
                dispatch(requestPensionPlanFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const requestSetAccount = (selectedId, selectedControlDigit, selectedContractNumber, selectedProduct, selectedBalance ) => ({
    type: actionTypes.BROKER_TRANSFER_PENSION_PLAN_INTERNAL_ASSOCIATE_ACCOUNT,
    payload: {
        selectedId,
        selectedControlDigit,
        selectedContractNumber,
        selectedProduct,
        selectedBalance
    }
});

const requestAditionalPlanData = (planId, immPlans, type) => (dispatch) => {
    const planData = immPlans.find(immPlan => {
        return immPlan.get('internalId') === planId
    })

    switch (type) {
        case BROKER_TRANSFER_PENSION_PLAN_ORIGIN:
            dispatch(setOriginPlan(planData));
            break;
        case BROKER_TRANSFER_PENSION_PLAN_DESTINATION:
            dispatch(setDestinationPlan(planData));
            break;
        default:
            break;
    }

    if(planData.get('comercialData')) {
        dispatch(getPensionPlanDetails(planData.getIn(['comercialData', 'SecId'])));
    } else {
        dispatch(requestPensionPlanNotFound());
    }
}
/* ***************************************************************************** */

/* Actions to fetch all pension plans minimun amount and DGScode. ************** */
const requestAllPensionPlanInProgress = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_ALL_PLANS_REQUEST
})

const requestAllPensionPlanSuccess = (immPlans, immAccounts, immProfile, comercialData) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_ALL_PLANS_SUCCESS,
    payload: {
        immPlans,
        immAccounts,
        immProfile,
        comercialData
    }
})

const requestAllPensionPlanInSearcherSuccess = (product, planData) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_SELECTED_IN_SEARCHER_SUCCESS,
    payload: {
        product,
        planData
    }
})

const requestAllPensionPlanFailure = (error) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_FETCH_ALL_PLANS_FAILURE,
    payload: {
        error
    }
})

const requestAllPensionPlans = () => (dispatch, getState) => {
    const immPlans = getState().brokerMyInvestments.getIn(['products', 'plans', 'stocks']);
    const immAccounts = getState().accounts;
    const immProfile = getState().profile;
    const securityDataPoints = 'SecId|ISIN|Name|CustomCategoryIdName|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomInstitutionSecurityId|ReturnM0|DGSCode';
    const typeId = BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;
    const requestData = {
        query: {
            securityDataPoints: securityDataPoints,
            pageSize:5000,
            outputType:'json',
            languageId:'es-ES',
            currencyId:'EUR',
            universeIds: SPAIN_PLANS_UNIVERSE_ID
        }
    };

    dispatch(requestAllPensionPlanInProgress());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreener', {type: typeId}), requestData)
        .then(response => {
            const comercialData = response.rows;
            dispatch(requestAllPensionPlanSuccess(immPlans, immAccounts, immProfile, comercialData));
        })
        .catch(response => {
            if (response.error) {
                dispatch(requestAllPensionPlanFailure(response.error.description));
            } else {
                throw response;
            }
        });
};
/* ***************************************************************************** */

const onSetOriginPlan = (planId, immPlans) => (dispatch) => {
    dispatch(requestAditionalPlanData(planId, immPlans, BROKER_TRANSFER_PENSION_PLAN_ORIGIN))
}

const onSetDestinationPlan = (planId, immPlans) => (dispatch) => {
    dispatch(requestAditionalPlanData(planId, immPlans, BROKER_TRANSFER_PENSION_PLAN_DESTINATION))
}

const changeDestinationOption = option => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_CHANGE_DESTINATION_OPTION,
        payload: {
            option
        }
    });
}

const changeTransferTypeOption = option => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_CHANGE_TRANSFER_TYPE_OPTION,
        payload: {
            option
        }
    })
}

const changeFiscalizationOption = option => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_CHANGE_FISCALIZATION_OPTION,
        payload: {
            option
        }
    })
}

const filterDestinationPlans = immPlans => (dispatch, getState) => {
    const originPlanId = getState().brokerTransferPensionPlansInternal
        .getIn(['steps', FIRST_STEP, 'originPlanData', 'internalId']);
    const plans = immPlans.filter(immPlan => {
        return immPlan.get('internalId') !== originPlanId && immPlan.get('comercialData');
    });
    const destinationPlanAlreadySelected = getState().brokerTransferPensionPlansInternal
        .getIn(['steps', SECOND_STEP, 'destinationPlanData', 'DGSCode']);
    const planFromWallet = plans.find(immPlan => {
            return destinationPlanAlreadySelected ? immPlan.getIn(['comercialData','DGSCode']) === destinationPlanAlreadySelected.toString() : false;
        })
    const isPlanFromWallet = !!planFromWallet;

    dispatch(setAvailableDestinationPlans(plans, isPlanFromWallet));
}

const requestPDFServiceSuccess = (response)  => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_PDF_SERVICE_SUCCESS,
    payload: {
        response
    }
})

const requestPDFServiceFailure = (response) => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_PDF_SERVICE_FAILURE,
    payload: {
        response
    }
})

const requestPDFService = () => ({
    type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_PDF_SERVICE_REQUEST
})

const requestConfirmation = (communicationInput) => (dispatch) => {
    dispatch(requestPDFService());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerTransferPensionPlanConfirm'), {query: communicationInput})
        .then(response => {
            dispatch(requestPDFServiceSuccess(response));
        })
        .catch(response => {
                dispatch(requestPDFServiceFailure(response.body));
        });
}

const onSetPlanSelectedFromSearch = (producto) => (dispatch, getState) => {
    const plansList = getState().brokerTransferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'availablePlansFromSearch'])
    const planData = plansList.toList().find(plan =>
            plan.get('SecId') === producto
        );

    dispatch(requestAllPensionPlanInSearcherSuccess(producto, planData));
    const secId = planData.get('SecId');
    dispatch(getPensionPlanDetails(secId))
};

const postPDFRequest = (dispatch, getState) => {
    const immBrokerTranferPensionPlansInternal = getState().brokerTransferPensionPlansInternal;
    const immSignaturePattern = getState().signaturePattern;
    const dataToken = immSignaturePattern.get('token');
    const originCountry = getState().profile.get('originCountry');

    const destinationPlanInWallet = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationTarget']);
    const selectedFiscOptionService = immBrokerTranferPensionPlansInternal.getIn(['steps', THIRD_STEP, 'selectedFiscOptionService']);
    const selectedTypeOptionService = immBrokerTranferPensionPlansInternal.getIn(['steps', THIRD_STEP, 'selectedTypeOptionService']);
    const transferType = immBrokerTranferPensionPlansInternal.getIn(['steps', THIRD_STEP, 'selectedTypeOption']);
    const transferAmount = immBrokerTranferPensionPlansInternal.getIn(['steps', THIRD_STEP, 'partialAportation']);
    const originPlanName = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'name']);
    const originPlanFund = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'pensionFund']);
    const originPlanContract = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'fullContractNumber']);
    const originPlanGestEntity = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'gestionEntity']);
    const originPlanDepositEntity = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'depositEntity']);
    const destinationPlanName = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'name']);
    const destinationPlanFund = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'pensionFund']);
    let destinationPlanContract;
    if (destinationPlanInWallet != BROKER_TRANSFER_PENSION_PLANS_DEST_NEW_OPTION) {
        destinationPlanContract = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'fullContractNumber'], '');
    }
    const destinationPlanGestEntity = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'gestionEntity']);
    const destinationPlanDepositEntity = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'depositEntity']);
    const destinationPlanAccount = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'associatedAccount', 'fullAccountNumber']);
    const dgsOrigin = immBrokerTranferPensionPlansInternal.getIn(['steps', FIRST_STEP, 'originPlanData', 'comercialData', 'DGSCode']);
    const dgsDestino = immBrokerTranferPensionPlansInternal.getIn(['steps', SECOND_STEP, 'destinationPlanData', 'DGSCode']);
    const fundamentalPlanDataUrl = apiURLBuilder.getURL('morningstarPlanLegalDocumentUrl', {dgscode: dgsDestino, documentType: BROKER_PLAN_LEGAL_DOCUMENT_DDFP, originCountry });
    const specificationsDocumentUrl = apiURLBuilder.getURL('morningstarPlanLegalDocumentUrl', {dgscode: dgsDestino, documentType: 'Especificaciones', originCountry });

    const communicationInput = {
        traspaso: selectedTypeOptionService,
        traspasoImporte: transferType === BROKER_TRANSFER_PENSION_PLAN_TYPE_PARTIAL_OPTION ? transferAmount.get('amount') : '',
        partidaFiscal: selectedFiscOptionService,

        ppOrigen: originPlanName,
        fpOrigen: originPlanFund,
        gestoraOrigen: originPlanGestEntity,
        depositariaOrigen: originPlanDepositEntity,
        numeroContratoOrigen: originPlanContract,

        ppDestino: destinationPlanName,
        fpDestino: destinationPlanFund,
        numeroContratoDestino: destinationPlanContract,
        gestoraDestino: destinationPlanGestEntity,
        depositariaDestino: destinationPlanDepositEntity,

        cuentaCorrienteAsociada: destinationPlanAccount,
        category: BROKER_PLANS_DOCUMENTS_CATEGORY,
        subcategoryTraspaso: BROKER_PLANS_TRANSFER_DOCUMENTS_SUBCATEGORY,
        subcategoryDocs: BROKER_HIRE_PENSION_PLAN_SUB_CATEGORY,
        datosFundamentalesUrl: fundamentalPlanDataUrl,
        especificacionesPlanUrl: specificationsDocumentUrl,

        dgsCodeOrigen: dgsOrigin,
        dgsCodeDestino: dgsDestino,
        mismaCartera: true,
        dataToken: dataToken,
    }
    dispatch(requestConfirmation(communicationInput));
}

const onSetAccount = (accountId) => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const immAccount = immAccounts.get('byId').toList().find(immAccount =>
        immAccount.get('accountId') === accountId
    );
    const selectedId = immAccount.get('accountId');
    const selectedControlDigit = immAccount.getIn(['ibanComplex','digitodecontrol']);
    const selectedContractNumber = immAccount.get('contractNumber');
    const selectedProduct = immAccount.get('product');
    const selectedBalance = immAccount.getIn(['balances', 'availableBalance']);
    dispatch(requestSetAccount(selectedId, selectedControlDigit, selectedContractNumber, selectedProduct, selectedBalance ))
}

const internalTransferConf = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        postPDFRequest(dispatch, getState, dataToken);
    };
    const isAlreadyFetching = getState().brokerTransferPensionPlansInternal.get('isFetching');

    if (!isAlreadyFetching) {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    }
};

const toggleDisclaimer = () => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_TRANSFER_PENSION_PLANS_INTERNAL_DISCLAIMER_TOGGLE
    })
}

module.exports = {
    changeAmountInput,
    changeDestinationOption,
    changeTransferTypeOption,
    changeFiscalizationOption,
    filterDestinationPlans,
    internalTransferConf,
    onSetOriginPlan,
    onSetDestinationPlan,
    onSetPlanSelectedFromSearch,
    onSetAccount,
    requestAllPensionPlans,
    reset,
    setAmountRange,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    toggleDisclaimer,
    validateStep
}
